/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getGlycanAssignments = `query GetGlycanAssignments(
  $groupProjectKey: ID!
  $limit: Int
  $nextToken: String
) {
  getGlycanAssignments(
    groupProjectKey: $groupProjectKey
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      groupProjectKey
      clusterId      
      runId
      preClusterId
      maxRetentionTime
      minRetentionTime
      structureId
      openMetaScore
    }
    nextToken
  }
}
`;
export const getMassGroupSummaries = `query GetMassGroupSummaries($projectId: ID!, $limit: Int, $nextToken: String) {
  getMassGroupSummaries(
    projectId: $projectId
    limit: $limit
    nextToken: $nextToken
  ) {
    items 
    nextToken
  }
}
`;
export const getGsmResultList = `query GetGsmResultList(
  $projectId: String!
  $runId: String!
  $preClusterId: String!
  $clusterId: String!
  $massGroup: String!
) {
  getGsmResultList(
    projectId: $projectId
    runId: $runId
    preClusterId: $preClusterId
    clusterId: $clusterId
    massGroup: $massGroup
  ) {
    metaScore
    structureId
    annotatedStructure
    annotationType
    annotationIndex
    glycanSpectrumMatches {
      gsmScore
      sugarStructure
    }
  }
}
`;
export const getStructureImage = `query GetStructureImage($scale: Float!, $structure: AWSJSON!) {
  getStructureImage(scale: $scale, structure: $structure) {
    base64
  }
}
`;
export const getSpectrumViewerData = `query GetSpectrumViewerData(
  $projectId: String!
  $runId: String!
  $preClusterId: String!
  $clusterId: String!
  $numberOfPeaks: Int!
) {
  getSpectrumViewerData(
    projectId: $projectId
    runId: $runId
    preClusterId: $preClusterId
    clusterId: $clusterId
    numberOfPeaks: $numberOfPeaks
  ) {
    peaks {
      x
      y
    }
  }
}
`;
export const createProject = `query CreateProject($query: CreateProjectInput) {
  createProject(query: $query) {
    projectId
    s3Objects {
      projectFile
      bucket
      key
      region
      url
      uploadUrl
    }
  }
}
`;
export const listProjects = `query ListProjects($limit: Int, $nextToken: String) {
  listProjects(limit: $limit, nextToken: $nextToken) {
    items {
      projectId
      projectName
    }
    nextToken
  }
}
`;
export const getDbStructures = `query GetDbStructures($mz: Float!, $charge: Int!, $projectId: String!) {
  getDBStructures(mz: $mz, charge: $charge, projectId: $projectId)
}
`;
